/* eslint-disable dot-notation */
import lider from '../../assets/img/lider.svg'
import unimarc from '../../assets/img/unimarc.svg'
import mayorista10 from '../../assets/img/10Img.svg'
import tottus from '../../assets/img/tottus1.svg'
import jumbo from '../../assets/img/jumbonew.svg'
import acuenta from '../../assets/img/acuentalogos.svg'
import alvi from '../../assets/img/alvilogos.svg'
import alvicl from '../../assets/img/alvipuntocl.png'
import cm from '../../assets/img/cmlogos.svg'
import cugat from '../../assets/img/cugatlogos.svg'
import famaycorona from '../../assets/img/famaycoronalogos.svg'
import ganga from '../../assets/img/gangalogos.svg'
import jumbologo from '../../assets/img/jumbologos.svg'
import kuncar from '../../assets/img/kuncarlogos.svg'
import monserrat from '../../assets/img/montserratlogos.svg'
import okmarketlogos from '../../assets/img/okmarketlogos.svg'
import santaisabellogos from '../../assets/img/santaisabellogos.svg'
import trebollogos from '../../assets/img/trebollogos.svg'
import unimarclogos from '../../assets/img/unimarclogos.svg'
import versluyslogos from '../../assets/img/versluyslogos.svg'
import super10logos from '../../assets/img/super10logos.svg'
import centralmayoristalogos from '../../assets/img/centralmayoristalogos.svg'
import express from '../../assets/img/expresslogos.svg'
import provimarket from '../../assets/img/provimarketlogos.svg'
import super9 from '../../assets/img/super9logo.svg'
import ohiggins from '../../assets/img/ohigginslogos.svg'
import super8 from '../../assets/img/super8logos.svg'
import tottuspuntocl from '../../assets/img/tottuspuntocl.png'
import jumbopuntocl from '../../assets/img/jumbopuntocl.png'
import liderpuntocl from '../../assets/img/liderpuntocl.png'
import unimarcpuntocl from '../../assets/img/unimarcpuntocl.png'
import santaisabelpuntocl from '../../assets/img/santaisabelpuntocl.png'
import ekono from '../../assets/img/ekono.png'
import spid from '../../assets/img/Spid.png'
import telemeracados from '../../assets/img/telemercado.png'


export const grocersBrandMap = {
	SPID:              { label: 'SPID',              bg: '#1A1A1A', color: '#1A1A1A' },
	EKONO:             { label: 'Ekono',             bg: '#E31E26', color: '#E31E26' },
	ACUENTA:           { label: 'aCuenta',           bg: '#C22026', color: '#C22026' },
	ALVI:              { label: 'Alvi',              bg: '#013F90', color: '#013F90' },
	'ALVI.CL':         { label: 'Alvi.cl',           bg: '#013F90', color: '#013F90' },
	CM:                { label: 'CM',                bg: '#FE0002', color: '#FE0002' },
	CUGAT:             { label: 'Cugat',             bg: '#FE671D', color: '#FE671D' },
	FAMAYCORONA:       { label: 'La Fama',           bg: '#EF7D00', color: '#EF7D00' },
	SUPERGANGA:        { label: 'Ganga',             bg: '#FDB500', color: '#9A6E00' },
	GANGA:             { label: 'Ganga',             bg: '#FDB500', color: '#9A6E00' },
	'JUMBO.CL':        { label: 'Jumbo.cl',          bg: '#00A215', color: '#00A215' },
	JUMBO:             { label: 'Jumbo',             bg: '#00A215', color: '#00A215' },
	KUNCAR:            { label: 'Kuncar',            bg: '#BE0922', color: '#BE0922' },
	'LIDER.CL':        { label: 'Lider.cl',          bg: '#007DC3', color: '#007DC3' },
	LIDER:             { label: 'Lider',             bg: '#007DC3', color: '#007DC3' },
	MAYORISTA10:       { label: 'Mayorista 10',      bg: '#E94E1B', color: '#E94E1B' },
	MONTSERRAT:        { label: 'Montserrat',        bg: '#DE051E', color: '#DE051E' },
	OKMARKET:          { label: 'OK Market',         bg: '#EE174D', color: '#EE174D' },
	OKM:               { label: 'OK Market',         bg: '#EE174D', color: '#EE174D' },
	SUPER10:           { label: 'Super 10',          bg: '#FE671D', color: '#FE671D' },
	SANTAISABEL:       { label: 'Santa Isabel',      bg: '#FD002B', color: '#FD002B' },
	'SANTAISABEL.CL':  { label: 'Santa Isabel.cl',   bg: '#FD002B', color: '#FD002B' },
	'STA.ISABEL':      { label: 'Santa Isabel',      bg: '#FD002B', color: '#FD002B' },
	'TOTTUS.CL':       { label: 'Tottus.cl',         bg: '#4BA82E', color: '#4BA82E' },
	TOTTUS:            { label: 'Tottus',            bg: '#4BA82E', color: '#4BA82E' },
	TELEMERCADO:       { label: 'Telemercado',       bg: '#0072BC', color: '#0072BC' },
	TREBOL:            { label: 'Trébol',            bg: '#059843', color: '#059843' },
	'UNIMARC.CL':     { label: 'Unimarc.cl',        bg: '#DE1F25', color: '#DE1F25' },
	UNIMARC:           { label: 'Unimarc',           bg: '#DE1F25', color: '#DE1F25' },
	VERSLUYS:          { label: 'Versluys',          bg: '#1A1A1A', color: '#1A1A1A' },
	CENTRALMAYORISTA:  { label: 'Central Mayorista', bg: '#FCC024', color: '#8A6800' },
	EXPRESS:           { label: 'Express',           bg: '#0F81C4', color: '#0F81C4' },
	PROVIMARKET:       { label: 'Provimarket',       bg: '#ED711E', color: '#ED711E' },
	'EL9':             { label: 'El 9',              bg: '#009950', color: '#009950' },
	"O'HIGGINS":       { label: "O'Higgins",         bg: '#0B0581', color: '#0B0581' },
	SUPER8:            { label: 'Super 8',           bg: '#164457', color: '#164457' },
}

export const getGrocersBrand = (grocersName) => {
	const key = String(grocersName).replace(/\s/g, '').toUpperCase()
	return grocersBrandMap[key] || { label: grocersName, bg: '#949494', color: '#464343ff' }
}

export const getGrocersImg = (grocersName) => {
	// console.log("CARGANDO IMAGEN DE::::::::::::  "+grocersName)
	const objImg = {
		SPID: spid,
		EKONO: ekono,
		ACUENTA: acuenta,
		ALVI: alvi,
		'ALVI.CL': alvicl,
		CM: cm,
		CUGAT: cugat,
		FAMAYCORONA: famaycorona,
		'SUPERGANGA': ganga,
		'GANGA': ganga,
		'JUMBO.CL': jumbopuntocl,
		JUMBO: jumbo,
		KUNCAR: kuncar,
		'LIDER.CL': liderpuntocl,
		LIDER: lider,
		MAYORISTA10: mayorista10,
		MONTSERRAT: monserrat,
		OKMARKET: okmarketlogos,
		OKM: okmarketlogos,
		SUPER10: super10logos,
		SANTAISABEL: santaisabellogos,
		'SANTAISABEL.CL': santaisabelpuntocl,
		'STA.ISABEL': santaisabellogos,
		// SPID: spid, // falta logo
		'TOTTUS.CL': tottuspuntocl,
		TOTTUS: tottus,
		TELEMERCADO: telemeracados, // ESTE LOGO FALTA!!!!
		TREBOL: trebollogos,
		'UNIMARC.CL': unimarcpuntocl,
		UNIMARC: unimarclogos,
		VERSLUYS: versluyslogos,
		CENTRALMAYORISTA: centralmayoristalogos,
		EXPRESS: express,
		PROVIMARKET: provimarket,
		'EL9': super9,
		"O'HIGGINS": ohiggins,
		'SUPER8': super8,
	}
	
	console.log("CADENA A ELEGIR:::::: " + String(grocersName).toUpperCase())
	return objImg[String(grocersName).toUpperCase()] || String(grocersName).toUpperCase()
}
